// extracted by mini-css-extract-plugin
export default {"quantityLabel":"styles_quantityLabel__dUcsG","iconTooltip":"styles_iconTooltip__WCzQO"};